export default "__VITE_ASSET__B_S8mzG7__"